import request from '@/utils/request'
import request1 from '@/utils/request1'
import { getToken } from '../utils/auth'

// 查询所有报警
export function queryalarm (params, data) {
  params.token = getToken()
  return request1({
    url: '/queryalarm',
    method: 'post',
    params,
    data
  })
}
// 按照人员查找历史警报
export function searchalarmbyperson (params, data) {
  params.token = getToken()
  return request({
    url: '/searchalarmbyperson',
    method: 'post',
    params,
    data
  })
}
// 获取总体数量统计
export function querydataviewcount (params, data) {
  return request({
    url: '/querydataviewcount',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 获取最近5条报警数据pid = 0 为网关设备
export function querydataviewalarm (params, data) {
  return request({
    url: '/querydataviewalarm',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 首页
export function querydataviewtypecount (data) {
  return request1({
    url: '/querydataviewtypecount',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 请求所有设备
export function querybinddevicelite () {
  return request({
    url: '/querybinddevicelite',
    method: 'post',
    params: { token: getToken() }
  })
}
// 根据人查找历史警报
export function queryalarmbypids (params, data) {
  params.token = getToken()
  return request({
    url: '/queryalarmbypids',
    method: 'post',
    params,
    data
  })
}
// 获取审核信息
export function querycheckinfo (params, data) {
  params.token = getToken()
  return request({
    url: '/querycheckinfo',
    method: 'post',
    params,
    data
  })
}
// 审核接口
export function approvecheckinfo (data) {
  return request({
    url: '/approvecheckinfo',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 获取是否有未批准的信息
export function querycheckinfovaliddate () {
  return request({
    url: '/querycheckinfovaliddate',
    method: 'post',
    params: { token: getToken() }
  })
}
// 查询报警
export function querysosalarmbyaid (data) {
  return request({
    url: '/querysosalarmbyaid',
    method: 'post',
    params: { token: getToken() },
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/alarmservice.js